import { GreenhouseLogo } from "./greenhouse_logo";
import { Body } from "./typography";
import "./footer.scss";
import { useBoardConfiguration } from "~/hooks/use_board_configuration";

export const Footer = () => {
  const { preview_mode } = useBoardConfiguration();
  return (
    <footer className="footer">
      <div className="footer-row">
        <Body>Powered by</Body>
        {preview_mode ? (
          <button className="footer-logo-link">
            <GreenhouseLogo height={30} width={100} />
          </button>
        ) : (
          <a
            className="footer-logo-link"
            target="_blank"
            href={"https://www.greenhouse.com"}
            rel="noreferrer"
          >
            <GreenhouseLogo height={30} width={100} />
          </a>
        )}
      </div>
    </footer>
  );
};
